import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../api/client";
import type { AdminAlert } from "../lib/adminAlerts";

// useAdminAlerts reads the open alerts on saved passes (0064,
// GET /api/v1/admin/alerts) every minute, also while the tab is in the
// background (the browser notifier's job). One query key, so the header's
// count, the Alerts page and the notifier share one request.
export function useAdminAlerts(enabled: boolean) {
  return useQuery({
    queryKey: ["admin", "alerts"],
    queryFn: async (): Promise<AdminAlert[]> => {
      const { data, error } = await apiClient.GET("/api/v1/admin/alerts");
      if (error) {
        const message = (error as { error?: { message?: string } }).error?.message;
        throw new Error(message || "the alerts could not be read");
      }
      return data?.alerts ?? [];
    },
    enabled,
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
  });
}
